import ElementTableSortable from './src/index';
import Vue from 'vue';

const createComponent = (component, props, parentVm) => {
  const ConCtor = Vue.extend(component);

  const EL = new ConCtor({
    parent: parentVm,
    store: parentVm?.$store,
    i18n: parentVm?.$i18n,
    propsData: props
  }).$mount();

  document.body.appendChild(EL.$el);

  EL.remove = () => {
    if (EL.$el && EL.$el.parentNode) {
      EL.$el.parentNode.removeChild(EL.$el);
    }
    EL.$destroy();
  };

  return EL;
};
const version = '1.1.1';
export default {
  version: version,
  install(Vue) {
    Vue.prototype.$initElementTableSortable = function(props) {
      return createComponent(ElementTableSortable, props, this);
    };
  },

};
